"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonModal = void 0;
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const Modal_1 = require("../Modal/Modal");
const GlobalStyles_1 = require("../../../helper/GlobalStyles");
const TherapyMonitorModal_styles_1 = require("../../organisms/TherapyMonitorModal/TherapyMonitorModal.styles");
const Breakpoints_1 = require("../../../helper/Breakpoints");
const CommonModal = ({ title, content, visible, onClose }) => {
    return (react_1.default.createElement(Modal_1.Modal, { modalVisible: visible, setModalVisible: () => { }, cb: () => { }, primaryButtonText: 'Ok', disableSecondaryButton: true, disablePrimaryButton: true },
        react_1.default.createElement(react_native_1.View, null,
            react_1.default.createElement(react_native_1.Text, { style: TherapyMonitorModal_styles_1.styles.modalTitle }, title),
            react_1.default.createElement(react_native_1.Text, { style: TherapyMonitorModal_styles_1.styles.modalPrompt }, content),
            react_1.default.createElement(react_native_1.View, { style: [GlobalStyles_1.globalStyles.modalButtonsContainer, TherapyMonitorModal_styles_1.styles.modalContent, Breakpoints_1.isDesktop && GlobalStyles_1.globalStyles.justifyCenter] },
                react_1.default.createElement(react_native_1.Pressable, { onPress: onClose, style: [GlobalStyles_1.globalStyles.followUpRecipeButton, GlobalStyles_1.globalStyles.followUpRecipeButtonPrimary] },
                    react_1.default.createElement(react_native_1.Text, { style: [GlobalStyles_1.globalStyles.buttonTextStyle] }, "Abbrechen"))))));
};
exports.CommonModal = CommonModal;
